const tiposNegocioCliente = [
    {
      'id': 'INDUSTRIA',
      'nome': 'Indústria'
    },
    {
      'id': 'COMERCIO',
      'nome': 'Comércio'
    },
    {
      'id': 'PRODUTOR_RURAL',
      'nome': 'Produtor Rural'
    }
  ]
  
  export default tiposNegocioCliente


// WEBPACK FOOTER //
// ./src/vuex/cache/tiposNegocioCliente.js